import { Injectable } from '@angular/core';
import { ObservabilityEvents, ObservabilityService } from '@mode/shared/util-observability';

@Injectable()
export class ReportViewerObservabilityService {
  constructor(private observabilityService: ObservabilityService) {}

  //if no scroll before render
  markVirtualReportRendered(reportToken: string) {
    this.markEvent(ObservabilityEvents.VIRTUALIZED_REPORT_RENDERED, reportToken);
  }

  //if we have scrolled before render
  markVirtualReportScrolledRendered(reportToken: string) {
    this.markEvent(ObservabilityEvents.VIRTUALIZED_REPORT_SCROLLED_RENDERED, reportToken);
  }

  markReportRendered(reportToken: string, isCaptureMode: boolean) {
    this.markEvent(ObservabilityEvents.REPORT_RENDERED, reportToken, isCaptureMode);
  }

  markReportCaptureRendering() {
    this.observabilityService.mark(ObservabilityEvents.REPORT_CAPTURE);
  }

  /**
   * Adds a final mark to the observation span and calls ObservabilityService to
   * record the page timing, closing the span.
   * @param markName
   * @param reportToken
   */
  private markEvent(markName: string, reportToken: string, isCaptureMode = false) {
    this.observabilityService.mark(markName);
  }
}
